<template>
  <div class="select">
    <input readonly type="text" :value="value&&value.map((i)=>i.name)" :placeholder="placeholder" class="input"
    @click="visible = true" />
    <Popup v-model="visible" position="bottom">
      <Area
        ref="checkbox"
        :columns-num="2"
        :value="city"
        :area-list="areaList"
        @cancel="visible = false"
        @confirm="onChange"
      />
    </Popup>
  </div>
</template>
<script>
import { Popup, Area } from 'vant';
// import Iconfont from '@/components/icon.vue';
export default {
  props: ['value', 'placeholder', 'areaList'],
  components: { Popup, Area },
  data() {
    return {
      visible: false,
      city: '110000,110100',
    };
  },
  mounted() {
    console.log('ref', this.$refs);
    setTimeout(() => {
      this.$refs.checkbox.reset();
    }, 0);
  },

  methods: {
    onChange(value) {
      //   const city = value.map(i => i.name);
      this.$emit('update:value', value);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: 100%;

  &::placeholder {
    color: #949aa4;
  }
}
</style>
